// Migrated from app/assets/javascripts/storage_access_api.js
// Safari Storage Access API helpers

function isSafari() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

function getCookieValue(name) {
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
}

// Set a hasAccess boolean variable which defaults to false.
let hasAccess = false;

async function handleCookieAccessInit() {
  // Check whether access has been granted via the Storage Access API.
  return await document.requestStorageAccess().then(
      () => {
        return 'hasAccess';
      },
      () => {
        return 'hasNoAccess';
      });
}

window.isSafari = isSafari;
window.getCookieValue = getCookieValue;
window.handleCookieAccessInit = handleCookieAccessInit;
